/**
 * 전략 비교 테이블 컴포넌트
 */
import { SectionCard } from '../common/SectionCard';
import './ComparisonTable.css';

interface ComparisonResult {
  strategy: string;
  return: number;
  sharpe: number;
  win_rate: number;
  max_drawdown: number;
  trades: number;
}

interface ComparisonTableProps {
  results: ComparisonResult[];
}

export default function ComparisonTable({ results }: ComparisonTableProps) {
  return (
    <SectionCard
      title="전략별 성과"
      subtitle={`${results.length}개 전략 비교 분석`}
    >
      <div className="comparison-table-wrapper">
        <table className="comparison-table">
          <thead>
            <tr>
              <th className="align-left">전략</th>
              <th className="align-right">수익률</th>
              <th className="align-right">샤프</th>
              <th className="align-right">승률</th>
              <th className="align-right">최대 낙폭</th>
              <th className="align-right">거래 수</th>
            </tr>
          </thead>
          <tbody>
            {results.map((result, i) => (
              <tr key={i}>
                <td className="font-medium">{result.strategy}</td>
                <td className={`align-right ${result.return >= 0 ? 'positive' : 'negative'}`}>
                  {result.return.toFixed(2)}%
                </td>
                <td className="align-right">{result.sharpe.toFixed(2)}</td>
                <td className="align-right">{result.win_rate.toFixed(2)}%</td>
                <td className="align-right warning-text">
                  {result.max_drawdown.toFixed(2)}%
                </td>
                <td className="align-right">{result.trades}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </SectionCard>
  );
}
